import { authRoleAccess } from 'auth/AuthRoleAccess'
import { lazy } from 'react'

const CaseHandle = lazy (() => import ('./CaseHandle.jsx'))      

const CaseHandleRoutes = [
    {
        path: '/CaseHandle',
        component: CaseHandle,
        auth: authRoleAccess.case_handle,
    },
   
]

export default CaseHandleRoutes 